<template>
<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
  <div class="datatables">
    <div class="block block-mode-hidden">
      <div v-if="tableLoader && showLoader" class="overlay"></div>
      <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#4EC37B" loading="loading" size="40" sizeUnit="px"></hash-loader>
      <div class="block-header bg-success">
        <h3 class="block-title text-white">
          <i class="fa fa-sitemap"></i> Items ({{ Object.keys(items).length }})
          <span class="hash-loader" v-if="showLoader && !tableLoader">
            <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
          </span>
        </h3>
        <div class="block-options">
          <button type="button" class="btn-block-option text-white" @click.prevent="showModifyItemModal(false, null)">
          <i v-bind:disabled="showLoader" class="si si-plus"></i> Add New
          </button>
          <button @click="tableLoader = !tableLoader" v-bind:disabled="showLoader" type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
        </div>
      </div>
      <div class="block-content block-content-full">
        <table id="items-table" class="table table-bordered table-striped table-vcenter js-dataTable-full table-sm">
          <thead>
            <tr>
              <th class="text-center">ID</th>
              <th>Name</th>
              <th class="no-sorting">Functions</th>
            </tr>
          </thead>
          <tbody>{{ getEntries }}
            <tr v-for="(item, index) in items" :key="index">
              <td class="text-center font-size-sm">{{ item.Id }}</td>
              <td class="font-w600 font-size-sm text-break-large">{{ item.Name }}</td>
              <td><a href="#" title="Edit" @click.prevent="showModifyItemModal(true, item)"><i class="fa fa-fw fa-pencil-alt"></i></a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!--Items modal window-->
  <ModifyItem ref="modifyItem" @loadItems="fetch" @showSuccessMsg="displaySuccessMsg"></ModifyItem>
</div>
</template>
<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import ModifyItem from '@/components/modals/ModifyItem';
Vue.use(VueSpinners);

export default {
  name: 'Item',
  data() {
    return {
      isTableEnabled: false,
      items: [],
      showLoader: false,
      tableLoader: false
    };
  },
  components: {
    HashLoader,
    ModifyItem
  },
  created() {
    this.fetch(false);
  },
  computed: {
    ...mapState({
      library: state => state.library
    }),
    getEntries() {
      if (this.$store.state.library.items.length) {
        return this.enableDataTable(this.$store.state.library.items);
      }
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllItems']),
    ...mapGetters('library', ['getItems']),
    async fetch(force) {
      if (force || this.getItems().length === 0) {
        this.showLoader = true;
        await this.getAllItems();
      }
      if (this.getItems().length === 0) {
        this.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#items-table').DataTable();
        table.destroy();
      }
      vm.items = data;
      vm.prepareDataTable('#items-table');
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    showModifyItemModal(isEdit, item) {
      if (isEdit) {
        this.$refs.modifyItem.loadItem(item);
      }
      jQuery('#modify_item').modal('show');
    },
    displaySuccessMsg(message) {
      this.success(message);
      this.triggerMessageModal('#alert_modal');
    },
    beforeDestroy() {
      this.clear();
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// source/components/boxes/Item.vue